import http from 'src/helper/http.js'

// 获取历届排行榜
export const apiGetHistoryRank = () => http.post('/web/weekly/history/rank')
export const apiUserGetHistoryRank = () => http.post('/web/weekly/user/history/rank')
export const apiUserGetHistoryRankStat = () => http.post('/web/weekly/user/rank/stat')
// 获取周星礼物
export const apiGetWeekGift = (daysago) => http.post('/web/weekly/gift', { daysago })
// 获取上周冠军
export const apiGetLastWeek = (daysago) => http.post('/web/weekly/top1', { daysago })
// 获取周星礼物排行榜
export const apiGetWeekGiftRank = (data) => http.post('/web/weekly/gift/user/rank', data)
export const apiGetRoomGiftRank = (daysago) => http.post('/web/weekly/group/rank', { daysago })
export const apiGetCountDown = () => http.post('/web/weekly/count/down')

export const apiGetFruitGift = () => http.post('/web/fruit/gift')
export const apiGetFruitRank = (daysago) => http.post('/web/fruit/week/rank', { daysago })
export const apiGetFruitMonthRank = (daysago) => http.post('/web/fruit/month/rank', { daysago })


// WEBPACK FOOTER //
// src/store/activity/week.js